<script>
import Notification from '../../reUse/Notification.vue';
import NastavitveIzpisi from "./Meni_nastavitve_izpisi.vue";
import NastavitveZig from "./Meni_nastavitve_zig.vue";
export default {
  components: {
    Notification,
    NastavitveIzpisi,
    NastavitveZig
  },
  emits: ['odjava'],
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Nastavitve izpisov</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="pregled-povrsin-container">
    <main class="main-content">
      <!-- NASTAVITVE IZPISOV -->
      <nastavitve-izpisi />

      <!-- NASTAVITVE ZIGA -->
      <nastavitve-zig />
    </main>
  </div>
</template>